<template>
    <el-pagination
        background
        layout="pager"
        :pager-count="pagerCount"
        :page-size.sync="pageSizeCpd"
        :current-page.sync="currentPageCpd"
        :total="total"
        @current-change="currentPageHandle"
        @size-change="sizeChangeHandle"
    >
    </el-pagination>
</template>

<script>
import Pagination from './Pagination.js'
export default Pagination
</script>

<style lang="scss" scoped>
@import './Pagination.scss';
</style>


// WEBPACK FOOTER //
// src/components/Pagination/Pagination.vue